import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value == null) return '';

    // Convert the value to a number if it's a string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    // If the value is NaN (not a valid number), return an empty string
    if (isNaN(numValue)) return '';

    // Format the number
    return numValue.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
